const getUrl = {
	getNews: '/news',
	// getBrands: '/brand/all',

	getMobile: '/mobile',
	getUsers: '/user/getAllUsers',
	getTableUsers: '/user/getAllPageableUsers',
	getUserById: '/user',
	getUserByEmail: '/user/getByEmailId',
	getAllEmployees: '/user/getAllEmployees',
	getAllFabricationPartners: '/user/getAllFabricationPartners',
	// getAllUserLocations: '/user/getAllUserLocations',
	getUserAddresses: '/user/getUserAddresses',
	unregisteredUsers: '/user/unregisteredUsers',
	getBillingAddresses: '/organisation/getBillingAddresses',
	getProjectCodes: '/organisation/getProjectCodes',
	getAllReporters: 'user/getAllReporters',
	getPastMonthTargets: 'user/getPastMonthTargets',

	getEnquiries: '/enquiry/getAllEnquiries',
	getEnquiryById: '/enquiry',
	getPreviewPoChecks: '/enquiry/previewPoChecks',
	addInOrderBook: '/enquiry/addInOrderBook',
	getBuyerEnquiries: '/enquiry/getAllEnquiriesOfBuyer',
	getSupplierEnquiries: '/enquiry/getAllQuotesOfSupplier',
	getAdminEnquiries: '/admin/enquiry/getAdminEnquiries',
	getAdminAssignedEnquiries: '/enquiry/getAssignedEnquiries',
	getAssignedEnquiriesForSupplyAdmin: '/enquiry/getAssignedEnquiriesForSupplyAdmin',
	getUnassignedEnquiries: '/enquiry/getUnassignedEnquiries',
	getScrapRequirement: '/enquiry/getScrapRequirement',
	getScrapSupplierQuotes: '/enquiry/getScrapSupplierQuotes',
	getScrapSupplierQuotesV2: '/enquiry/v2/getScrapSupplierQuotes',
	getExpectedTransitTime: '/enquiry/getExpectedTransitTime',
	getEnquiriesByOrderGiven: '/enquiry/getByOrderGiven',
	getEnquirySummaryStatus: '/enquiry/enquiry-summary-status',
	getSupplierQuoteSummary: '/enquiry/getSupplierQuoteSummary',
	getEnquiryChecks: '/enquiry/checks',

	getOrders: '/order/getAllOrders',
	getAllAdminOrders: '/admin/order/getAllOrders',
	getActiveInvoices: '/order/getActiveInvoices',
	getAllActiveInvoices: '/admin/order/getActiveInvoices',
	getVehicleStatusSummary: 'order/getVehicleStatusSummary',
	getOrderById: '/order/getOrderById',
	getPurchaseOrders: '/order/getAllPurchaseOrdersOfUser',
	getSupplierOrders: '/order/getAllSupplyOrdersOfUser',
	getAllOrderDetails: '/order/getAllOrderDetails',

	getProductById: '/product',
	getProducts: '/product/getAll',
	getProductOfCategory: '/product/getProductsOfCategory',

	getCategories: '/category/getAll',
	getCategoryById: '/category',
	getTopCategories: '/category/getTop',

	getAllBrand: '/brand/all',

	getAllLedgersOfUser: '/ledger/getLedgersOfUser',
	getPurchaseInvoices: '/ledger/getAllPurchaseInvoicesOfUser',
	getSaleInvoices: '/ledger/getAllSaleInvoicesOfUser',
	getAllLedgers: '/ledger/getAllLedgers',
	getAllLedgerSummary: '/ledger/getAllLedgerSummary',
	getLedgerSummaryByOrganisationId: '/ledger/getLedgerSummaryByOrganisationId',
	getduePaymentsReport: '/ledger/duePaymentsReport',

	getAllPaymentReceivable: '/payment-receivables/all',
	getPaymentReceivablesById: 'payment-receivables/getById',
	getCollectionByOrgId: '/payment-receivables/getAllByOrganisationId',
	getAllClientsForCollection: '/payment-receivables/getAllClientsForCollection',
	getDueLedgerReport: '/ledger/dueLedgerReport',
	getDueInvoices: '/invoice-payment/getDueInvoices',
	getAllInvoicePayments: '/invoice-payment/getAll',
	getByPaymentId: '/invoice-payment/getByPaymentId',
	getByDocumentNo: '/invoice-payment/getByDocumentNo',
	getDataCorrectionList: 'ledger/getDataCorrectionList',

	downloadFile: 'files/loadDocument',

	getUserDashboard: 'dashboard/getUserDashboardData',
	getCompanyDashboard: 'dashboard/getCompanyDashboardData',
	getManagerDashboardData: 'dashboard/getManagerDashboardData',
	getUsersMonthlyTarget: 'dashboard/getUsersMonthlyTarget',
	getPendingOrder: 'dashboard/getPendingOrder',
	getOrganisationDashboardData: 'dashboard/getOrganisationDashboardData',
	getCompanyDashboardDataV2: 'dashboard/v2/getCompanyDashboardData',
	getLatestDashBoardHtmlFile: 'dashboard/getLatestDashBoardHtmlFile',

	getAllAuctions: '/auction/getAllAuctions',
	getAllAuctionsOfSupplier: '/auction/getAllAuctionsOfSupplier',
	getAllQuotesOfBuyer: '/auction/getAllQuotesOfBuyer',
	getAdminAuctions: '/auction/getAdminAuctions',
	getAssignedAuctions: '/auction/getAssignedAuctions',
	getAuctionById: '/auction',

	getLogisticsById: '/logistics/getLogisticsRequestById',
	getAllLogistics: '/logistics/getAllLogisticsRequests',
	getAllLogisticsOrders: '/logistics/getAllLogisticsOrders',
	getLogisticsOrderById: '/logistics/getLogisticsOrderById',
	getAllLogisticsOrdersOfUser: 'logistics/getAllLogisticsOrdersOfUser',
	getAllLogisticsRequestsOfUser: '/logistics/getAllLogisticsRequestsOfUser',
	getLogisticsRequestById: '/logistics/getLogisticsRequestById',
	getAllProductPhotosBuyer: '/order/getAllProductPhotosBuyer',

	getLogisticsQuoteById: '/logistics',
	getAllLogisticsRequests: '/logistics/getAllLogisticsRequests',

	getAllMachineTemplates: '/machine/getAllMachineTemplates',
	getMachineById: '/machine/getMachineById',

	getFactoryById: '/factory/getFactoryById',
	getAllFactories: '/factory/getAllFactories',
	getFactoriesOfUser: '/factory/getAllFactoriesOfUser',
	getAllFabricationOrdersOfUser: '/factory/getAllFabricationOrdersOfUser',
	getAllFabricationOrders: 'factory/getAllFabricationOrders',
	searchOutputItemsById: 'factory/searchOutputItemsById',
	getFabricationOrderById: 'factory/getFabricationOrderById',

	getEnquiryReportData: 'reports/enquiry/dataReport',
	getInvoiceReportData: 'reports/invoice/customerInvoice',
	getOrderMisReportV2: 'reports/orders/mis/v2',

	getEnquiryMISReport: 'reports/enquiry/mis',
	getEnquiryMISReportV2: 'reports/v2/enquiry/mis',
	getEnquiryMISSupplierQuoteReport: 'reports/enquiry/supplierQuote/mis',
	getEnquiryMISSupplierItemWiseReport: 'reports/enquiry/supplierQuote/mis/itemwise',
	getEnquiryMISSalesReport: 'reports/enquiry/sales/mis',
	getEnquiryMISSalesItemWiseReport: 'reports/enquiry/salesQuote/mis/itemwise',
	getEnquiryCategoryMonthlyReport: 'reports/enquiry/category-weight-monthly',
	getEnquiryManagerByReport: 'reports/enquiry/by-manager',
	getBuyerEnquiryCohortReport: 'reports/enquiry/user-cohort',
	getUserDataReport: 'reports/users/data',
	getZohoUsers: 'reports/zoho-users',
	getInvoiceOrderAmountMismatchReport: 'reports/invoiceOrderAmountMismatch',
	getCustomerRevenueReport: 'reports/internal/customerRevenueReport',
	getMonthlyOrderReport: 'reports/internal/monthlyOrderReport',
	getSimilarOrganisationReport: 'reports/internal/similarOrganisations',
	getMissingServicedWeightInvoices: '/reports/internal/missingServicedWeightInvoices',
	getLedgerWiseGrossMarginReport: 'reports/ledgerWiseGrossMargin',
	getLedgerWiseGrossMarginV2Report: 'reports/V2/internal/ledgerWiseGrossMargin',
	getInternalDeletedOrderLedger: 'reports/internal/deletedOrderLedger',
	getReceivablesComparison: 'reports/internal/getReceivablesComparison',
	getNewUserReport: 'reports/user/newUserReport',
	getKycReport: 'reports/organisation/kycReport',
	getPaymentReceivablesReport: 'reports/paymentReceivablesReport',
	getAgeingReceivablesReport: '/reports/ageingReceivable/organisation',
	getAgeingReceivablesTypeReport: '/reports/ageingReceivable/due',
	getSupplierAllotedWeight: '/reports/order/supplierAllottedWeight',
	getOrderPoAgeReport: '/reports/order/orderPoAge',
	getsupplyMarginReport: '/reports/order/supplyMargin',
	pendingWeightReport: '/reports/order/pendingWeight',
	getPodTriggeredInvoices: '/reports/order/podTriggeredInvoices',

	fetchOrderBook: 'reports/order/book',

	getPastRecords: 'zoho/getAllPastRecords',
	getPastRecordOfUser: 'zoho/getPastRecordOfUser',
	getrefreshAllPastRecords: '/zoho/refreshAllPastRecords',
	refreshZohoContacts: '/zoho/refreshZohoContacts',

	getSupplierQuotesReport: 'reports/users/bestSupplierQuotes',
	getMonthlyInvoiceReport: 'reports/invoice/monthly',
	getOrderMISReport: 'reports/orders/mis',
	getBuyerPendingWeightReport: 'reports/buyer/pendingWeight',
	getBuyerOrderMisInvoiceWise: 'reports/order/buyerQuote/mis/invoiceWise',
	getBuyerOrderMisItemwise: '/reports/order/buyerReport/mis/itemWise',
	getSupplierOrderMisInvoiceWise: 'reports/order/supplierQuote/mis/invoiceWise',
	getSupplierOrderMisItemwise: 'reports/order/supplierReport/mis/itemWise',
	getMonthlyInvoicingDetails: 'reports/order/monthlyInvoicingDetails',

	getlogisticsPrices: 'logisticsPrices/getAll',
	getlogisticsPricesById: 'logisticsPrices/getById',
	getLogisticsPricesRangeByPinCodes: 'logisticsPrices/getByPinCodes',
	getAllLogsitcsByEnquiryId: '/logistics/getByEnquiryId',
	getAllCommodityPrices: 'commodity-price/getAll',
	getLatestCommodityPrices: 'commodity-price/getLatestPrices',
	getAllCommodity: '/commodity/all',

	getUserMessages: 'userInteraction/getUserData',
	getAdminMessages: 'userInteraction/getAdminData',
	getNotifications: 'userInteraction/recentNotifications',

	getAllInvoice: '/invoice/getAll',
	downloadBills: '/export/downloadBills',

	getBankDetails: '/financials/report/getBankDetails',
	getCreditReports: '/financials/report/all',
	getReportById: '/financials/report/getReportById',
	getAllReports: '/financials/report/getAllReports',
	restartBankStatementAnalysis: '/financials/report/restartBSA',
	getBSAExcelReport: '/financials/report/downloadBSAExcel',
	latestReport: 'financials/report/latestReport',

	gettrips: '/order/trips',
	getZohoClientId: '/zoho/grantCode',
	fetchContactId: '/zoho/fetchContactId',

	downloadUsers: '/export/downloadUsers',
	downloadFabricationOrders: '/export/downloadFabricationOrders',
	downloadLedgers: '/export/downloadLedgers',
	downloadOrders: '/export/downloadOrders',
	downloadActiveInvoices: '/export/downloadActiveInvoices',
	downloadZohoPastRecord: '/export/downloadZohoPastRecord',
	exportLeads: '/export/downloadLeads',

	getAllCreditRequest: '/requestCredit/getAllCreditRequest',
	getAllBanners: '/banner/getAllBanners',
	getBlogById: '/content/',
	getAllBlog: '/content/blog/all',

	getAllContentNews: '/content/news/all',
	getAllContent: '/content/all',

	getAllClients: '/organisation/getAllClients',
	getOrganisationByUser: '/organisation/getOrganisationByUser',
	getAllOrgSuppliers: '/organisation/getAllSuppliers',
	getAllLogisticPartners: '/organisation/getAllLogisticPartners',
	getAllOrganisationLocations: '/organisation/getAllOrganisationLocations',
	getAllOrganisations: '/organisation/getAllOrganisations',
	getAllOrganisationsV2: '/organisation/v2/getAllOrganisations',
	getOrganisation: '/organisation',
	getOrganisationCreditDetails: '/organisation/organisationCreditDetails',
	getUsersOfOrganisation: '/organisation/getUsersOfOrganisation',
	getOrganisationKycData: '/organisation/getOrganisationKycData',
	getSubsidiaries: '/organisation/getSubsidiaries',
	getAllAccountDetails: '/organisation/getAllAccountDetails',
	getAccountDetailsByGst: '/organisation/getAccountDetailsByGst',
	getAllEnquiryPhoto: '/enquiryPhoto/all',
	getJourneyBySourceId: '/journey',
	getEntityHistoryVersions: '/history/',
	getLedgersOfUser: '/ledger/getLedgersOfUser',
	getLedgerSummaryByOrgId: '/ledger/getLedgerSummaryByOrganisationId',
	getAllLeadOrganisations: '/lead/all',
	getLeadById: '/lead/',
	getLeadJourneyByOrgId: '/lead/leadJourney',
	getLeadsByOrgId: '/lead/getLeadsByOrg',
	getMeetingList: '/lead/meetingList',
	getAllTaskReminders: '/lead/getAllTaskReminders',
	downloadLeads: '/export/downloadLeads',
	fetchCompanyReport: '/reports/fetchCompanyReport',
	fetchOrganisationReport: '/reports/fetchOrganisationReport',
	downloadPaymentReceivables: '/export/downloadPaymentReceivables',
	getMonthlyTarget: '/user/getMonthlyTarget',
	generateReport: 'financials/generateReport',
	getPdcByOrganisation: '/financials/getPdcByOrganisation',
	getOrgWarehouses: '/organisation/warehouses',
	getManufacturerLocations: '/extra/get-supplier-locations',

	getAllPunchOrder: '/punchOrder/all',
	getPunchOrderById: '/punchOrder',

	getCreditLimitByOrdId: '/creditLimit/organisation',

	getAllGlossary: '/glossary/all',
	getGlossaryById: '/glossary/getById',
	getGlossaryBySlug: '/glossary/getBySlug',
	getPanByCompanyName: 'extra/getPan',
	getAllSupplyOrder: 'supplierOrder/getAllSupplierOrder',
	getSpoById: 'supplierOrder',
	getOrganisationProbeDetails: '/probe42/getProbe42Details',
	getProbeBriefDetails: '/probe42/brief-details',
	getProbeFinancials: '/probe42/financials',
	getProbeFinancialDetails: '/probe42/financial-details',
	getProbeCompliance: '/probe42/compliance',
	getProbeCharges: '/probe42/charges',
	getProbeShareholdings: '/probe42/shareholdings',
	fetchFromProbe42: '/probe42/fetch-from-probe42',
	getAllProbeReports: '/probe42/all',
	experianCreditReport: '/experian/credit-report',
	getOrganisationCreditScoreAndPdf: '/organisation/getCreditScoreAndPdf',

	getCranReportById: '/cranReport/getById',
	getInspectionReportById: '/cranReport/getInspectionReport',
	generateCranReport: '/cranReport/generateCranReport',
	getInspectionReports: '/cranReport/getAllInspectionReports',
	getNewInspectionReport: 'cranReport/getNewInspectionReport',
	getRecentVotingDetails: 'cranReport/voterByOptionId',
	getAllCranReports: '/cranReport/getAllCranReports',
	getCranReport: '/cranReport/getCranReport',
	checkActiveInspectionReport: '/cranReport/checkActiveInspectionReport',

	getActiveDispatchPlans: '/dispatchPlan/getDispatchPlanReport',
	getDispatchPlansBySPO: '/dispatchPlan/getAllDispatchPlansBySpoNo',
	getAllDispatchPlans: '/dispatchPlan/getAllDispatchPlans',
	getAllDispatchPlanCards: '/dispatchPlan/getAllDispatchPlanCards',
	getByDispatchPlanId: '/dispatchPlan/getById',
	getDispatchPlansByOrderId: '/dispatchPlan/getAllDispatchPlansByOrderId',
	getDetailedDispatchReport: 'dispatchPlan/detailedDispatchReport',
	getDispatchReportByPlatform: 'dispatchPlan/dispatchReportByPlatform',
	vehicleKyc: '/order/vehicleKyc',

	getShipmentRequestsByOrderId: '/shipmentRequest/order',
	getShipmentRequestById: '/shipmentRequest',
	getAllShipmentsByRM: '/shipmentRequest/getAllShipmentsByRM',
	getShipmentRequestDraft: '/shipmentRequest/draft',
	getShipmentRequestSupplyResponse: '/shipmentRequest/supplyResponse',
	getShipmentRequestSupplyResponseDraft: '/shipmentRequest/supplyResponse/draft',
	getApprovedFulfillmentPlans: '/shipmentRequest/fulfillmentPlans/approved',
	getAllFulfillmentPlans: '/shipmentRequest/fulfillmentPlans/all',
	getDispatchPlanDraft: '/shipmentRequest/dispatchPlan/draft',
	getFulfillmentPlanById: '/shipmentRequest/fulfillmentPlan',

	getLeaderboardHierarchy: 'leaderboard/getHierarchy',
	getLeaderboardSalesHierarchy: 'leaderboard/getSalesHierarchy',
	getHighestEnquiryWeight: 'leaderboard/getHighestEnquiryWeight',
	getHighestMarginAndPercentage: 'leaderboard/getHighestMarginAndPercentage',
	getHighestOrderWeight: 'leaderboard/getHighestOrderWeight',
	getHighestRevenue: 'leaderboard/getHighestRevenue',
	getTotalOverdue: 'leaderboard/getTotalOverdue',
	getHighestDispatch: 'leaderboard/getHighestDispatch',
	getHighestSupplierQuotes: 'leaderboard/getHighestSupplierQuotes',
	getHighestQuoteConversion: 'leaderboard/getHighestQuoteConversion',
	getHighestOrderGivenQuotes: 'leaderboard/getHighestOrderGivenQuotes',
	getHighestUniqueSupplierQuoted: 'leaderboard/getHighestUniqueSupplierQuoted',
	getHighestNewSupplierOnboarded: 'leaderboard/getHighestNewSupplierOnboarded',
	getApprovalMetrics: '/creditApproval/approval/all',
	getApprovalEnquirySummary: '/creditApproval/approval/enquiry/summary',
	getUserCreditSummary: '/creditApproval/approval/user/credit-summary',
	getOverdueInvoices: '/creditApproval/approval/overdue/invoices',
	getApprovalMessages: '/creditApproval/approval/messages',
	getApprovalsByReferenceId: '/creditApproval/approval/enquiry',

	getAdminPastRecords: '/admin/past-records/',
	getBusinessDetails: '/cranReport/getBusinessDetails',
}

export default getUrl
